import React from 'react';

export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error.message, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
        <h1 style={{ fontSize: 20 }}>Something went wrong</h1>
        <p>Reload the page. If it keeps happening, let us know.</p>
        <pre style={{ whiteSpace: 'pre-wrap', fontSize: 12, color: '#b00' }}>
          {this.state.error.message}
        </pre>
      </div>
    );
  }
}
